module.exports = __webpack_public_path__ + "img/design3.7590e1b1.png";